import { PublicClientApplication } from '@azure/msal-browser';

const environmentConfig = {
	prod: '192d5e61-1db2-42f6-8dba-bc6df0fe3128',
	stg: 'ee024e44-1dd1-49b3-80c3-73166e6bdaee',
	dev: '0358aa0f-5980-4f3e-bbb9-e1789c2d46e1',
};

// REACT_APP_ENV is set in .gitlab-ci.yml build script
const currentEnv = process.env.REACT_APP_ENV || 'dev';
const clientId = process.env.REACT_APP_CLIENT_ID || environmentConfig[currentEnv];

const msalConfig = {
	auth: {
		clientId: clientId,
		authority: 'https://login.microsoftonline.com/d8d0ad3e-8bcf-48e9-9bb2-aee17c6c4fd5',
		redirectUri: '/',
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: true,
	},
};

export const msalClient = new PublicClientApplication(msalConfig);
